import(/* webpackMode: "eager" */ "/vercel/path0/app/_lib/assets/images/bg-gradient.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
